module.exports = "/static/images/star-icon.svg";